exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n\n.list-container{\n\tcolor:white;\n}\n/*a little bit of reset*/\n#services-list, #services-list p, #services-list h3 {\nlist-style: none;\nmargin:20px; padding:0;\n}\n#services-list > li{\n  float:left;\n  margin-right: 20px;\n  width: 100%;\n}\n#services-list > li > .image{\n  display:block;\n  float:left;\n  margin-right:10px;\n}\n/*\nthis instructions are to force the dimensions of image and its container <a>\n*/\n#services-list > li > .image,\n#services-list > li > .image > img{\n  width:170px; height:150px;\n}\n.gallery-component-footer{\n    margin:0 auto;\n\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    text-align: center;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/haydenso/Desktop/Code/Projects/haydensookchand/website_source/src/app/gallery/gallery.component.css
// module id = ../../../../../src/app/gallery/gallery.component.css
// module chunks = main